/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import {
  datosFormDatosPersonales,
  datosFormExtendido,
  datosFormPassword,
  datosPrivacidad,
  tooltips,
} from 'utils/formData';
import {
  IEdicionAdmin,
  IEdicionUsuario,
  IFormato,
  IFormDatosPersonales,
  IFormExtendido,
  IFormRegistroAdmin,
  IFormSocio,
  IFormulario,
  IRegistro,
  ISelectOptions,
} from 'utils/models/interfaces';
import { Taller } from 'utils/models/types';
import { useLocation, useParams } from 'react-router-dom';
import {
  formatoFechaYYYYMMDD,
  limpiarDefaultValues,
  crearOpcionesTipos,
  crearOpcionesTalleresUsuario,
} from 'utils/utilities';
import { edicionAdminPut, edicionUsuarioPut } from 'services/servicioPut';
import { useError } from 'services/ErrorContext';
import Formulario from '../Formulario/Formulario';
import { registroUsuario } from 'services/auth/ServicioAuth';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import { fetchSelectTalleres } from 'utils/redux/features/talleresSelectSlice';
import Spinner from 'components/public/Spinner/Spinner';
import { Box } from '@mui/material';
import { HowToReg } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import NoResponse from '../../../pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { fetchTiposRol } from 'utils/redux/features/tiposRolesSlice';
import { fetchTiposSocio } from 'utils/redux/features/tiposSocioSlice';
import { fetchUsuarioId } from 'utils/redux/features/usuarioIdSlice';
import { anchoMaxForms, anchoMaxLogueado } from 'utils/constants';
interface IFormUsuario {
  titulo: string;
  variante: 'registroUsuDesdeAdmin' | 'registroUsu' | 'edicionCatsUsuDesdeAdmin' | 'edicionUsu';
  textoBoton: string;
}

const FormUsuario = ({ titulo, variante, textoBoton }: IFormUsuario) => {
  const [mensajeExito, setMensajeExito] = useState('');

  const usuarioJSON = localStorage.getItem('usuario');
  const usuario = usuarioJSON && JSON.parse(usuarioJSON);
  const { id } = useParams();

  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const { error, setError, clearError, loading, setLoading } = useError();
  const { usuario: usuarioAEditar, loadingUsuario, errorUsuario } = useSelector((state: RootState) => state.usuarioId);
  const { talleresSelect, loadingTalleresSelect, errorTalleresSelect } = useSelector(
    (state: RootState) => state.talleresSelect
  );
  const { tiposRol, loadingTiposRol, errorTiposRol } = useSelector((state: RootState) => state.tiposRol);
  const { tiposSocio, loadingTiposSocio, errorTiposSocio } = useSelector((state: RootState) => state.tiposSocio);
  const edicionUsuario = !location.pathname.includes('/usuarios');
  const usu = edicionUsuario ? usuario : usuarioAEditar;
  const fechaNacimiento = usu?.FechaNac && new Date(usu?.FechaNac);
  const tipoSocioId = tiposSocio.find(tipo => tipo.Nombre === usu?.TipoSocio)?.Id;
  const tipoRolId = tiposRol.find(tipo => tipo.Nombre === usu?.Rol)?.Id;

  const tituloExitoRegistro = 'Registro Exitoso';
  const tituloExitoEdicion = 'Edición exitosa';

  const tituloResp =
    variante === 'registroUsu' || variante === 'registroUsuDesdeAdmin' ? tituloExitoRegistro : tituloExitoEdicion;

  useEffect(() => {
    dispatch(fetchSelectTalleres());
    if (variante === 'edicionCatsUsuDesdeAdmin') {
      dispatch(fetchTiposRol());
      dispatch(fetchTiposSocio());
    }
    id && dispatch(fetchUsuarioId(Number(id)));
  }, [dispatch, variante]);

  const edicionDatosPersonales = [
    {
      name: 'nombre',
      label: 'Nombre',
      halfWidth: 'left',
      defaultValue: usu?.Nombre,
      disabled: false,
      adornment: 'account',
    },
    {
      name: 'apellido',
      label: 'Apellido',
      halfWidth: 'right',
      defaultValue: usu?.Apellido,
      disabled: false,
      adornment: 'account',
    },
    { name: 'email', label: 'Email', inputType: 'email', defaultValue: usu?.Email, disabled: true, adornment: 'email' },
    { name: 'confirmEmail', label: 'Confirmar email', inputType: 'email', adornment: 'email' },
    {
      name: 'password',
      label: 'Contraseña',
      inputType: 'password',
      halfWidth: 'left',
      pattern: tooltips.password.pattern,
      tooltip: tooltips.password.tooltip,
      adornment: 'eye',
    },
    {
      name: 'password',
      label: 'Confirmar contraseña',
      inputType: 'password',
      halfWidth: 'right',
      pattern: tooltips.password.pattern,
      tooltip: tooltips.password.tooltip,
      adornment: 'eye',
    },
  ];

  const datosFormEdicionAdmin: IFormato<IFormRegistroAdmin>[] = [
    {
      name: 'descuentoAsignado',
      label: 'Descuento',
      defaultValue: usu?.DescuentoAsignado,
      inputType: 'number',
      halfWidth: 'left',
      adornment: '%',
    },
    {
      name: 'rol',
      label: 'Rol de usuario',
      inputType: 'select',
      halfWidth: 'right',
      required: false,
      defaultValue: tipoRolId,
    },
    {
      name: 'esAlumno',
      label: '¿Es alumno?',
      inputType: 'checkbox',
      halfWidth: 'left',
      required: false,
      defaultValue: usu?.EsAlumno,
    },
    {
      name: 'esSocio',
      label: '¿Es socio?',
      inputType: 'checkbox',
      halfWidth: 'right',
      required: false,
      defaultValue: tipoSocioId !== 3 ? true : false,
    },
    {
      name: 'esElenco',
      label: '¿Es elenco?',
      inputType: 'checkbox',
      halfWidth: 'left',
      required: false,
      defaultValue: usu?.EsElenco,
    },
    {
      name: 'activo',
      label: 'Usuario activo',
      inputType: 'checkbox',
      halfWidth: 'right',
      required: true,
      disabled: true,
      defaultValue: usu?.Activo,
    },
    {
      name: 'talleres',
      label: 'Talleres',
      inputType: 'select',
      defaultValue: usu?.Talleres?.length > 0 ? usu?.Talleres : talleresSelect[0],
      required: false, // Porque puede ser alumno y no estar más inscripto a talleres porque terminaron. Pero no se deja de ser alumno.
    },
  ];

  const datosFormEdicionSocio: IFormato<IFormSocio>[] = [
    {
      name: 'tipoSocio',
      label: 'Tipo de socio',
      inputType: 'select',
      required: false,
      defaultValue: tipoSocioId,
    },
  ];

  const datosFormEdicionExtendido: IFormato<Omit<IFormExtendido, keyof IFormDatosPersonales>>[] = [
    {
      name: 'telefono',
      label: 'Teléfono',
      required: false,
      defaultValue: usu?.Telefono,
      inputType: 'tel',
      pattern: tooltips.telefono.pattern,
      tooltip: tooltips.telefono.tooltip,
      adornment: 'tel',
    },
    {
      name: 'fechaNac',
      label: 'Fecha de nacimiento',
      inputType: 'date',
      required: false,
      defaultValue: usu?.FechaNac ? formatoFechaYYYYMMDD(fechaNacimiento) : undefined,
    },
  ];

  const datosEdicionUsuario = edicionDatosPersonales.filter(
    el => !el.label.includes('Confirmar') && el.name !== 'password'
  );

  const datosPersonalesRegistro = limpiarDefaultValues(datosFormDatosPersonales);
  const datosFormExtendidoRegistro = limpiarDefaultValues(datosFormExtendido);

  const cargarDatos = () => {
    let datosUsuario: any[] = [];
    switch (variante) {
      case 'registroUsuDesdeAdmin':
        datosUsuario = [...datosPersonalesRegistro, ...datosFormPassword, ...datosFormExtendidoRegistro];
        break;
      case 'registroUsu':
        datosUsuario = [
          ...datosPersonalesRegistro,
          ...datosFormPassword,
          ...datosFormExtendidoRegistro,
          ...datosPrivacidad,
        ];
        break;
      case 'edicionCatsUsuDesdeAdmin': // Editar a otro usuario desde listado de usuarios
        datosUsuario = datosEdicionUsuario.map(el => ({
          ...el,
          disabled: el.name === 'nombre' || el.name === 'apellido' || el.name === 'email' ? true : false,
        }));
        datosUsuario = [...datosUsuario, ...datosFormEdicionAdmin, ...datosFormEdicionSocio];
        break;
      case 'edicionUsu':
        datosUsuario = [...datosEdicionUsuario, ...datosFormEdicionExtendido];
        break;
    }
    return datosUsuario;
  };

  const opcionesTipoSocioUsu: ISelectOptions[] = crearOpcionesTipos(tiposSocio, 'tipoSocio');
  const opcionesTipoRolUsu: ISelectOptions[] = crearOpcionesTipos(tiposRol, 'rol');
  const opcionesTalleres: ISelectOptions[] = crearOpcionesTalleresUsuario(talleresSelect, 'talleres', usu?.Talleres);
  const esRegistro = variante === 'registroUsu' || variante === 'registroUsuDesdeAdmin';

  const mensajeAlertaRegistro =
    variante === 'registroUsu'
      ? 'Después de verificar tu cuenta podrás iniciar sesión.'
      : 'La persona recibirá un correo de verificación para completar el registro.';

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError(); // Limpiar errores antes de hacer una nueva request

    const mensajeRegistroUsu = '¡Gracias por registrarte en Teatro Bosch!';
    const mensajeRegistroAdmin = '¡El nuevo usuario ha sido generado con éxito!';
    const mensajeEdicionAdmin = '¡Los datos del usuario fueron actualizados con éxito!';
    const mensajeEdicionUsu = '¡Tus datos fueron actualizados con éxito!';

    switch (variante) {
      case 'registroUsu':
      case 'registroUsuDesdeAdmin':
        const requestRegistro: IRegistro = {
          Nombre: data.nombre,
          Apellido: data.apellido,
          Email: data.email,
          Password: data.password,
          ConfirmPass: data.ConfirmPass,
          RolId: data.rol,
          FechaNac: data.fechaNac?.toString() || null,
          DescuentoAsignado: 0,
          Telefono: data.telefono || '',
          EsElenco: false,
          EsAlumno: false,
          TipoSocioId: data.tipoSocio,
          Talleres: data.talleres || [],
        };

        try {
          const respuestaRegistro = await registroUsuario(requestRegistro, setError, setLoading);
          setMensajeExito(variante === 'registroUsu' ? respuestaRegistro || mensajeRegistroUsu : mensajeRegistroAdmin);
        } catch (err) {
          // El error ya se manejó en setError de postData
        }

        break;

      case 'edicionCatsUsuDesdeAdmin':
        const idTalleresUsu = usu?.Talleres?.map((taller: Taller) => taller.Id);
        const nuevosTalleres =
          Array.isArray(data.talleres) && data.talleres.filter(idTaller => !idTalleresUsu?.includes(idTaller));
        const requestEdicionAdmin: IEdicionAdmin = {
          Id: usu?.Id,
          RolId: data.rol || 2,
          DescuentoAsignado: Number(data.descuentoAsignado) || 0,
          EsElenco: data.esElenco || false,
          EsAlumno: data.esAlumno || false,
          TipoSocioId: data.tipoSocio || 3,
          Activo: data?.activo,
          Talleres: nuevosTalleres || [],
        };

        try {
          await edicionAdminPut(requestEdicionAdmin, setError, setLoading);
          setMensajeExito(mensajeEdicionAdmin);
        } catch (error) {
          console.error('Error de edición:', error);
        }
        break;

      case 'edicionUsu': // Acá es siempre el usuario que está logueado
        const fechaNacimientoDate = data.fechaNac && new Date(data.fechaNac);
        const fechaNacimientoISOString = fechaNacimientoDate && fechaNacimientoDate.toISOString();

        const requestEdicionUsu: IEdicionUsuario = {
          Id: usu.Id,
          Nombre: data?.nombre,
          Apellido: data?.apellido,
          FechaNac: fechaNacimientoISOString || null,
          Telefono: data?.telefono || '',
        };

        try {
          await edicionUsuarioPut(requestEdicionUsu, setError, setLoading);
          setMensajeExito(mensajeEdicionUsu);
        } catch (error) {
          console.error('Error de edición:', error);
        }
        break;
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
  };

  const error401 = errorUsuario?.includes('permisos');
  const desdeAdmin = variante === 'edicionCatsUsuDesdeAdmin' || variante === 'registroUsuDesdeAdmin';

  return (
    <>
      {desdeAdmin && (loadingTalleresSelect || loadingUsuario || loadingTiposRol || loadingTiposSocio) ? (
        <Spinner />
      ) : (
        <Box maxWidth={desdeAdmin ? anchoMaxLogueado : anchoMaxForms} mx="auto">
          {errorTalleresSelect || errorUsuario || errorTiposRol || errorTiposSocio ? (
            error401 ? (
              <NotAllowed />
            ) : (
              <NoResponse />
            )
          ) : (
            <Formulario
              mensajeExito={mensajeExito}
              mensajeError={error}
              tituloMensajeResp={tituloResp}
              onSubmit={handleSubmit}
              onVolver={handleVolver}
              loading={loading}
              datos={opcionesTipoRolUsu.concat(opcionesTipoSocioUsu).concat(opcionesTalleres)}
              campos={cargarDatos()}
              anchoMax={600}
              titulo={titulo}
              textoBoton={textoBoton}
              variante="claro"
              iconoBoton={HowToReg}
              mensajeAlerta={esRegistro ? mensajeAlertaRegistro : ''}
            />
          )}
          {usuario && variante === 'registroUsu' && !mensajeExito && (
            <Typography variant="h6" fontSize="14px" maxWidth={600} margin="auto" mt={-2}>
              * Más adelante podrás asignar categorías al usuario creado, desde el listado de usuarios
            </Typography>
          )}
        </Box>
      )}
    </>
  );
};

export default FormUsuario;
